import { pref } from "@-/toolbox/pref.svelte.ts";

/** changes the app's font size */
export const fontSize = pref("fontSize", 1, v => {
	document.documentElement.style.fontSize = v + "rem";
});

// the default fonts are purely to make the windows look not suck as much
// otherwise i'd just go with system-ui, monospace, and sans-serif

/** changes the user interface font */
export const uiFont = pref("uiFont", '"Segoe UI Variable", system-ui, sans-serif', v => {
	document.documentElement.style.setProperty("--set-uiFont", v);
});

/** changes the monospace font */
export const monoFont = pref("uiFont", '"Cascadia Code", monospace', v => {
	document.documentElement.style.setProperty("--set-monoFont", v);
});

/** changes the prose font */
export const proseFont = pref("proseFont", "sans-serif", v => {
	document.documentElement.style.setProperty("--set-proseFont", v);
});

/** changes the width of the central component containing the posts */
export const contentWidth = pref("contentWidth", 768, v => {
	document.documentElement.style.setProperty("--set-contentWidth", v + "px");
});

/** changes the accent color */
export const primaryColor = pref("accent", 166.36, v => {
	document.documentElement.style.setProperty("--set-accent", v.toString());
});

/** changes the direction of the light effect, in degrees */
export const lightDir = pref("lightDir", 160, v => {
	document.documentElement.style.setProperty("--set-lightDir", v + "deg");
});

/** changes the intensity of the light effect, in percent, recommended 0-30 */
export const lightIntensity = pref("lightIntensity", 15, v => {
	document.documentElement.style.setProperty("--set-lightIntensity", v + "%");
});

/** changes the "spread" of ceratin glowing elements, in percent */
export const glowSpread = pref("glowSpread", 120, v => {
	document.documentElement.style.setProperty("--set-glowSpread", (v / 100).toString());
});

/** changes the roundness of the UI */
export const rounding = pref("rounding", 1, v => {
	document.documentElement.style.setProperty("--set-rounding", v.toString());
});

/** current language */
export const lang = pref("lang", "en");

/** show 12-hour timestamps on hover */
export const twelveHour = pref("12hour", false);

/** show relative timestamps */
export const relativeTime = pref("relativeTime", true);

export const activeSessions = pref<[/* network */ string, /* sessionId */ string][]>(
	"activeSessions",
	[],
);

export const enableClass = (value: boolean, className: string) => {
	const classes = document.documentElement.classList;
	if (value) classes.add(className);
	else classes.remove(className);
};
